document.addEventListener("DOMContentLoaded", () => {
  const targetSelector = `[action="/search"] .search-field`;
  let debounceTimer;

  document.addEventListener("input", (e) => {
    // Kiểm tra xem phần tử kích hoạt sự kiện có khớp với selector mục tiêu hay không
    if (e.target && e.target.matches(targetSelector)) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        window.dispatchEvent(new Event('scroll'));
      }, 300);
    }
  });
});